import {
    HashLocationStrategy,
    LocationStrategy,
    PathLocationStrategy,
} from '@angular/common';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ToastModule } from 'primeng/toast';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { ConfigInitService } from './demo/service/config-init.service';
import { FirebaseModule } from './demo/service/firebase.module';
import { FirebaseTestService } from './demo/service/firebase-test.service';
import { AuthService } from './demo/service/auth.service';
import { AuthInterceptor } from './demo/service/auth.interceptor';
import { LoginComponent } from './demo/components/auth/authentication/login.component';
import { ForgotPasswordComponent } from './demo/components/auth/authentication/forgot-password.component';
import { ResetPasswordComponent } from './demo/components/auth/authentication/reset-password.component';
import { VerifyEmailChangeComponent } from './demo/components/auth/authentication/verify-email-change.component';
import { NewPasswordComponent } from './demo/components/auth/authentication/new-password/new-password.component';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        VerifyEmailChangeComponent,
        NewPasswordComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        InputTextModule,
        PasswordModule,
        ToastModule,
        AppLayoutModule,
        AppRoutingModule,
        FirebaseModule,
    ],
    providers: [
        ConfigInitService,
        FirebaseTestService,
        AuthService,
        {
            provide: APP_INITIALIZER,
            useFactory: (authService: AuthService) => () => authService.init(),
            multi: true,
            deps: [AuthService],
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        { provide: LocationStrategy, useClass: HashLocationStrategy },

        { provide: LOCALE_ID, useValue: 'en-US' }, // MM/DD/YYYY
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
